import { _ as t } from "../internals/export.js";
import { f as r } from "../internals/function-uncurry-this-clause.js";
import { f as e } from "../internals/fails.js";
import { a as s } from "../internals/array-buffer.js";
import { a as n } from "../internals/an-object.js";
import { t as i } from "../internals/to-absolute-index.js";
import { t as o } from "../internals/to-length.js";
import { s as a } from "../internals/species-constructor.js";
var f = s.ArrayBuffer,
  m = s.DataView,
  l = m.prototype,
  p = r(f.prototype.slice),
  u = r(l.getUint8),
  c = r(l.setUint8);
t({
  target: "ArrayBuffer",
  proto: !0,
  unsafe: !0,
  forced: e(function () {
    return !new f(2).slice(1, void 0).byteLength;
  })
}, {
  slice: function slice(t, r) {
    if (p && void 0 === r) return p(n(this), t);
    for (var e = n(this).byteLength, s = i(t, e), l = i(void 0 === r ? e : r, e), j = new (a(this, f))(o(l - s)), h = new m(this), y = new m(j), b = 0; s < l;) c(y, b++, u(h, s++));
    return j;
  }
});